<template>
  <tr :style="{cursor: clickable ? 'pointer' : 'default'}" @click="(e: Event) => handleClick(e)">
    <td v-if="expandable" :class="['checkbox-expanded', {'border-0': isExpanded}]">
      <BootstrapCheck
        :id="`checkbox-expand-${value}`"
        v-model="modelExpanded"
        :value="value"
        button
        :icon="icon"
      />
    </td>
    <td v-if="selectable" :class="['checkbox-selected', {'border-0': isExpanded}]">
      <BootstrapCheck
        :id="`checkbox-select-${value}`"
        v-model="modelSelected"
        :value="value"
        :disabled="disabled"
      />
    </td>
    <slot></slot>
  </tr>
</template>
<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    expandable?: boolean;
    nested?: boolean;
    expanded?: string[];
    selectable?: boolean;
    selected?: string[];
    clickable?: boolean;
    value?: string;
    disabled?: boolean;
  }>(),
  {
    expandable: false,
    expanded: () => [],
    selectable: false,
    selected: () => [],
    value: '',
    disabled: false,
  },
);
const emits = defineEmits<{
  'update:selected': [selected: string[]];
  'update:expanded': [expanded: string[]];
  clickInline: [];
}>();
const modelSelected = computed({
  get: () => props.selected,
  set: (value) => emits('update:selected', value),
});
const modelExpanded = computed({
  get: () => props.expanded,
  set: (value) => emits('update:expanded', value),
});
const isExpanded = computed(() => modelExpanded.value.includes(props.value) && props.nested);
const icon = computed(() => {
  const icon = isExpanded.value
    ? 'material-symbols:keyboard-arrow-up'
    : 'material-symbols:keyboard-arrow-down';
  return props.nested ? icon : '';
});
const handleClick = (e: Event) => {
  const el = e.target as HTMLElement;
  const isSelf = el.tagName === 'TD' || el.tagName === 'TR';
  const selection = window.getSelection()?.toString();
  if (props.clickable && isSelf && !selection) emits('clickInline');
  else return true;
};
</script>
<style lang="scss" scoped>
.checkbox-expanded :deep(.btn) {
  border: 0;
}
</style>
